<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { v6 as uuidv6 } from 'uuid';
import { useCookie } from '#imports';

const config = useRuntimeConfig();

const showBanner = ref(true);
const COOKIE_NAME = 'cookie_consent';
const cookieConsent = useCookie<string | null>(COOKIE_NAME, {
    default: () => null,
    maxAge: 60 * 60 * 24 * 365,
    path: '/'
});

onMounted(() => {
    if (cookieConsent.value) {
        showBanner.value = false;
    }
})

async function acceptCookies() {
    try {
        const uuid = uuidv6();

        cookieConsent.value = uuid;

        const userAgent = navigator.userAgent;
        const date = new Date().toISOString();

        await $fetch(`${config.public.baseUrlBackend}/api/cookie-consent`, {
            method: 'POST',
            body: {
                uuid: uuid,
                userAgent: userAgent,
                date:   date,
            },
            headers: {
                'Accept': 'application/json',
            },
        });

        showBanner.value = false;
    } catch (error) {
        console.error('Erro ao registrar consentimento:', error);
    }
}
</script>

<template>
    <div
        v-if="showBanner"
        class="
            bg-[#EBE9E9]
            z-2
            fixed
            bottom-0
            text-xs lg:text-sm 2xl:text-md
            2xl:!max-w-[1920px]
        "
    >
        <div
            class="
                flex
                flex-col md:flex-row
                items-center
                justify-center
                w-full
            "
        >
            <p
                class="
                    text-color-primary
                    pt-12
                    pl-12 md:pl-6 lg:pl-20
                    pr-12 md:pr-2 2xl:pr-20
                    pb-10 md:pb-12
                "
            >
                Nosso portal utiliza cookies necessários para o seu funcionamento e que permitem coletar dados anonimizados de navegação para que possamos medir e melhorar o desempenho do nosso website, além de observar hábitos de visita, que permitem lembrar suas preferências. Os cookies podem ser estabelecidos por nós ou por fonecedores externos cujos serviços adicionamos às nossas páginas. Além dos cookies, estão habilitados plugins de determinadas redes sociais que poderão tratar seus dados quando você optar por acessar o nosso site por meio delas.
            </p>

            <div class="flex flex-col items-center justify-center w-full px-10 md:px-6 lg:pr-20">
                <button
                    class="
                        bg-color-primary
                        text-white
                        text-xs lg:text-sm 2xl:text-md
                        2xl:max-w-80
                        cursor-pointer
                        py-10 md:py-5
                        w-full
                    "
                    @click="acceptCookies"
                >
                    Prosseguir
                </button>

                <a
                    href="https://atosoficiais.com.br/unochapeco/resolucao-consun-n-10-2021-aprova-o-encaminhamento-da-materia-politica-de-privacidade-e-de-uso-de-cookies-do-portal-unochapeco-e-portal-fundeste-para-deliberacao-junto-a-fundeste?origin=instituicao"
                    class="
                        text-color-primary
                        text-xs lg:text-sm 2xl:text-md
                        underline
                        mt-3 mb-6
                    "
                    target="_blank"
                >
                    Política de Privacidade
                </a>
            </div>
        </div>
    </div>

</template>
